export const medicineLogActions = {
  FETCH_PICKER_LOG_SUCCESS: "FETCH_PICKER_LOG_SUCCESS",
  ADD_TO_PICKER_LOG: "ADD_TO_PICKER_LOG",
  FETCH_CHECKER_LOG_SUCCESS: "FETCH_CHECKER_LOG_SUCCESS",
  ADD_TO_CHECKER_LOG: "ADD_TO_CHECKER_LOG",
};

export function addToCheckerLog(props) {
  return (dispatch) => {
    let existingPickerLog = props.checkerLog;
    let newItem = props.newOrder;
    if (
      existingPickerLog &&
      existingPickerLog.filter((e) => e.orderId === newItem.orderId).length > 0
    ) {
      const index = existingPickerLog.findIndex((e) => {
        return e.orderId === newItem.orderId;
      });
      existingPickerLog[index] = newItem;
    } else {
      existingPickerLog.push(newItem);
    }

    dispatch({
      type: medicineLogActions.ADD_TO_CHECKER_LOG,
      payload: existingPickerLog,
    });
  };
}
export function addToPickerLog(props) {
  return (dispatch) => {
    let existingPickerLog = props.pickerLog;
    let newItem = props.newOrder;

    if (
      existingPickerLog &&
      existingPickerLog.filter((e) => e.orderId === newItem.orderId).length > 0
    ) {
      let tempMedList = existingPickerLog.filter(
        (e) => e.orderId === newItem.orderId
      )[0].MedList;
      if (
        tempMedList.filter((e) => e.productCode === newItem.productCode)
          .length === 0
      ) {
        tempMedList.push(newItem);
      }

      existingPickerLog.map((e, i) => {
        if (e.orderId === newItem.orderId) {
          let temp = e;
          temp.MedList = tempMedList;
          return temp;
        } else {
          return e;
        }
      });
    } else {
      let temp = [];
      temp.push(newItem);
      existingPickerLog.push({
        orderId: newItem.orderId,
        MedList: temp,
      });
    }
    dispatch({
      type: medicineLogActions.ADD_TO_PICKER_LOG,
      payload: existingPickerLog,
    });
  };
}
